(function() {

    const redirects = {
        "https://cbdliving.com/collections/thc-chocolate": "https://smokingdog.com/collections/chocolate",
        
        "https://cbdliving.com/collections/thc-drinks": "https://smokingdog.com/collections/seltzer",

        "https://cbdliving.com/collections/thc-seltzer": "https://smokingdog.com/collections/seltzer",

        "https://cbdliving.com/collections/thc-brownie": "https://smokingdog.com/products/smoking-dog-thc-brownie-mix-500mg",

        "https://cbdliving.com/collections/thc-gummies": "https://smokingdog.com/collections/gummies",

        "https://cbdliving.com/collections/thc-edibles": "https://smokingdog.com/collections/gummies",

        "https://cbdliving.com/collections/thc-lemonades": "https://smokingdog.com/collections/lemonade",

        "https://cbdliving.com/collections/thc-shots": "https://smokingdog.com/collections/shots",

        "https://cbdliving.com/collections/thc-syrup": "https://smokingdog.com/collections/syrup",

        "https://cbdliving.com/collections/thc-topicals": "http://smokingdog.com/collections/freezze-roll-on",

        "https://cbdliving.com/collections/full-spectrum-cbd-thc": "https://smokingdog.com/products/thc-soft-gels",
        

        

    
    };

    function checkRedirect() {
        const currentUrl = window.location.href.split('?')[0];

        if (redirects[currentUrl]) {
            window.location.replace(redirects[currentUrl]);
        }
    }

    checkRedirect();

    setInterval(checkRedirect, 500);

})();